import React from 'react'

export default function CamPivot({item}) {
  return (
     <>
     <tr className="table_rows">
                <td className="boldfont">Daily</td>
                <td className="boldfont">PP</td>
                <td>{item.cpp ? item.cpp : ""} </td>
              </tr>

              <tr className="table_rows">
                <td className="boldfont">S1</td>
                <td>{item.csone ? item.csone : ""} </td>
                <td className="boldfont">R1</td>
                <td>{item.crone ? item.crone : ""} </td>
              </tr>
              <tr className="table_rows">
                <td className="boldfont">S2</td>
                <td>{item.cstwo ? item.cstwo : ""} </td>
                <td className="boldfont">R2</td>
                <td>{item.crtwo ? item.crtwo : ""} </td>
              </tr>
              <tr className="table_rows">
                <td className="boldfont">S3</td>
                <td>{item.csthree ? item.csthree : ""} </td>
                <td className="boldfont">R3</td>
                <td>{item.crthree ? item.crthree : ""} </td>
              </tr>

              <tr className="table_rows highlited_row">
                <td className="boldfont">Weekly</td>
                <td className="boldfont">PP</td>
                <td>{item.cwpp ? item.cwpp : ""} </td>
                <td></td>
              </tr>

              <tr className="table_rows">
                <td className="boldfont">S1</td>
                <td>{item.cwsone ? item.cwsone : ""} </td>
                <td className="boldfont">R1</td>
                <td>{item.cwrone ? item.cwrone : ""} </td>
              </tr>
              <tr className="table_rows">
                <td className="boldfont">S2</td>
                <td> {item.cwstwo ? item.cwstwo : ""}</td>
                <td className="boldfont">R2</td>
                <td>{item.cwrtwo ? item.cwrtwo : ""} </td>
              </tr>
              <tr className="table_rows">
                <td className="boldfont">S3</td>
                <td>{item.cwsthree ? item.cwsthree : ""} </td>
                <td className="boldfont">R3</td>
                <td>{item.cwrthree ? item.cwrthree : ""} </td>
              </tr>
              <tr className="table_rows highlited_row">
                <td>Monthly</td>
                <td className="boldfont">PP</td>
                <td>{item.cmpp ? item.cmpp : ""} </td>
                <td></td>
              </tr>
              <tr className="table_rows">
                <td className="boldfont">S1</td>
                <td>{item.cmsone ? item.cmsone : ""} </td>
                <td className="boldfont">R1</td>
                <td> {item.cmrone ? item.cmrone : ""}</td>
              </tr>

              <tr className="table_rows">
                <td className="boldfont">S2</td>
                <td>{item.cmstwo ? item.cmstwo : ""} </td>
                <td className="boldfont">R2</td>
                <td> {item.cmrtwo ? item.cmrtwo : ""}</td>
              </tr>
              <tr className="table_rows">
                <td className="boldfont">S3</td>
                <td>{item.cmsthree ? item.cmsthree : ""} </td>
                <td className="boldfont">R3</td>
                <td> {item.cmrthree ? item.cmrthree : ""}</td>
              </tr>
              </>
  )
}
